import React from 'react';
import { Tooltip } from '../../../../tooltip/tooltip';
import { InlineIcon } from '../../../../inline-icon/inline-icon';
import MoreIcon from '../../../../../icons/compiled/components/MoreIcon';
import styles from './styles.scss';
export class More extends React.Component {
  render() {
    const {
      className,
      onClick,
      dataHook,
      ariaLabel,
      tooltip
    } = this.props;
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip
    }, /*#__PURE__*/React.createElement("button", {
      "data-hook": dataHook,
      onClick: onClick,
      className: `${className} ${styles.icon}`,
      "aria-label": ariaLabel
    }, /*#__PURE__*/React.createElement(InlineIcon, {
      icon: /*#__PURE__*/React.createElement(MoreIcon, null)
    })));
  }
}
//# sourceMappingURL=more.js.map